import { render, staticRenderFns } from "./RemoteFolderConfigurationDetails.vue?vue&type=template&id=f4f0b244&"
import script from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f0b244')) {
      api.createRecord('f4f0b244', component.options)
    } else {
      api.reload('f4f0b244', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationDetails.vue?vue&type=template&id=f4f0b244&", function () {
      api.rerender('f4f0b244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolder/RemoteFolderConfigurationDetails.vue"
export default component.exports